import { Time } from '@/ui/Time';

export const NotificationTime = ({ notification = {} }) => {
  return (
    <Time
      time={notification?.created_at}
      color="secondary-700"
      fontSize="12px"
      fontWeight="medium"
      display="inline"
    />
  );
};
